/* ============================================================================
   dd-event-hero.js

   Keeps the hero ticket-stub price (`[data-dd-event-price]`) in sync with the
   variant selected in the buy box. The stub is server-rendered from
   `product.selected_or_first_available_variant`; when the shopper switches
   variants (e.g. with / without toolkit) Dawn publishes
   PUB_SUB_EVENTS.variantChange with the new variant JSON — we re-render the
   amount from `variant.price` (cents).

   Hard rules honoured:
     • Zero Shopify fetches — the price arrives in the pub/sub payload
       (rate-limit-awareness).
     • Singleton guard so a re-injected section script can't double-subscribe.
     • Price gating: the stub price is deliberately guest-visible (carve-out in
       hide-price-guest.liquid), and variantChange fires for guests too, so no
       customer check is needed here.
   ========================================================================== */
(function () {
  'use strict';
  if (window._ddEventHeroPriceInit) return;
  window._ddEventHeroPriceInit = true;

  /* Mirrors Liquid's `| money` (keeps trailing .00) so a JS update is
     indistinguishable from the server render. */
  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = window.shopMoneyFormat ? String(window.shopMoneyFormat) : '${{amount}}';
    fmt = fmt.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/g, '');
    var fixed = (Number(cents) / 100).toFixed(2);
    var intPart = fixed.split('.')[0];
    var decPart = fixed.split('.')[1];
    return fmt
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/gi,
        groupThousands(intPart, '.') + ',' + decPart
      )
      .replace(
        /\{\{\s*amount_no_decimals\s*\}\}/gi,
        groupThousands(String(Math.round(Number(cents) / 100)), ',')
      )
      .replace(/\{\{\s*amount\s*\}\}/gi, groupThousands(intPart, ',') + '.' + decPart);
  }

  function updateAll(priceCents) {
    var els = document.querySelectorAll('[data-dd-event-price]');
    if (!els.length) return;
    var text = formatMoney(priceCents);
    if (!text) return;
    els.forEach(function (el) {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  /* Dispensed-ticket flourish: while the hero ticket strip is out of the
     viewport, <html> carries `dd-hero-ticket-gone` and the mini ticket in
     the sticky ATC (.dd-sf-ticket-pop, dd-event-hero.css) slides up from
     behind the ATC button. Scrolling the hero strip back into view slides
     it back down. Pure class toggle — zero fetches, zero polling. */
  function initTicketPop() {
    if (!('IntersectionObserver' in window)) return;
    var strip = document.querySelector('.dd-event-ticket--strip');
    if (!strip || !document.querySelector('.dd-sf-ticket-pop')) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        document.documentElement.classList.toggle('dd-hero-ticket-gone', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(strip);
  }

  function initPrice() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (!document.querySelector('[data-dd-event-price]')) return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data ? event.data.variant : null;
      if (!variant || variant.price == null) return;
      updateAll(variant.price);
    });
  }

  function init() {
    initPrice();
    initTicketPop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
